import type { IconData } from '@stacksjs/iconify-core'

export const keyF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m10.026 17.609l-2.121-2.122a1 1 0 1 0-1.415 1.415l2.122 2.12l-2.475 2.476l-4.43-.296a1 1 0 0 1-.932-.93L.48 15.84l6.898-6.898a7 7 0 1 1 5.657 5.657l-3.01 3.009zm3.535-9.193a2 2 0 1 0 2.829-2.828a2 2 0 0 0-2.829 2.828\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default keyF
